var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Attachments',{staticClass:"project-attachments",attrs:{"value":_vm.item.media.attachments}})
}
var staticRenderFns = []

export { render, staticRenderFns }